































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import {
  getConfig,
  getFailExcel,
  getPageExcel,
  getPageList,
  getTempExcel,
  relationPagePublish, saveAllocateExcel,
  savePageExcel,
  updatePageStatus
} from '@/services/api'
import {AmPageDetail, AmPageQuery, AmPageStatus, ConfigType, DownloadRes} from "@/model/AmPage";
import store from "@/store";
import {Message} from "element-ui";

@Component({})
export default class PageList extends Vue {
  // 控制列表高度
  public tableHeight = window.innerHeight - 160;
  // excel下载截流控制
  public excelCtrl = true;
  public tempCtrl = true;
  public failInfoCtrl = true;
  //主页创建日期
  public createDate: string[] = [];
  // 申诉日期
  public appealDate: string[] = [];
  // 状态列表
  public pageStatusList: {desc: string, code: number}[] = [];
  public publishStatusList: {desc: string, code: number}[] = [];
  public appealStatusList: {desc: string, code: number}[] = [];
  public pageOwnerList: {desc: string, code: number}[] = [];
  public pageStatusMap: {[prop: string]: string} = {};
  public publishStatusMap: {[prop: string]: string} = {};
  public appealStatusMap: {[prop: string]: string} = {};
  public pageOwnerMap: {[prop: string]: string} = {};
  // 上传表单
  public formData: AmPageQuery = {
    pageNum: 1,
    pageSize: 20
  };
  // 列表总数
  public totalNum = 0;

  // 关联发布
  public associatePageId:string|undefined = '';
  public associatePageDetail: AmPageDetail = {};
  public associatePageList: AmPageStatus[] = [];
  public associatePageVisible = false;

  // 批量导出
  public downloadResVisible = false;
  public downloadRes: DownloadRes = {};

  // 列表数据
  public tableData: AmPageDetail[] = [];

  public pickerOptions = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker: any) {
        const end = new Date(), start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  };

  /**
   * 初始化方法
   */
  async created(): Promise<void> {
    window.onresize = () => {
      try {
        this.tableHeight = window.innerHeight - 160;
      } catch (e) {}
    }
    await this.getPageList();
    this.getConfig('pageStatusList', ConfigType.PageStatus, 'SET_PAGE_STATUS_LIST', 'pageStatusMap');
    this.getConfig('publishStatusList', ConfigType.PublishStatus, 'SET_PUBLISH_STATUS_LIST', 'publishStatusMap');
    this.getConfig('appealStatusList', ConfigType.AppealStatus,'SET_APPEAL_STATUS_LIST', 'appealStatusMap');
    this.getConfig('pageOwnerList', ConfigType.PageOwner,'SET_PAGE_OWNER_LIST', 'PageOwnerMap');
  }

  /**
   * 获取item列表
   */
  async getPageList(): Promise<void> {
    this.formData.createDateStart = this.createDate && this.createDate[0];
    this.formData.createDateEnd = this.createDate && this.createDate[1];
    this.formData.appealDateStart = this.appealDate && this.appealDate[0];
    this.formData.appealDateEnd = this.appealDate && this.appealDate[1];
    await getPageList(this.formData, true).then(res => {
      if (res.data && res.data.code === 200) {
        this.tableData = res.data.data.list || [];
        this.totalNum =  res.data.data.total || 0;
      }
    }).catch(() => {})
  }

  /**
   * 获取字典信息
   */
  getConfig(listName: string, type: ConfigType, method: string, listMapName: string): void {
    const listMap: { [prop: string]: string } = {};
    if (!this.$store.state[listName] || this.$store.state[listName]?.length === 0) {
      getConfig({type}).then(res => {
        if (res.data && res.data.code === 200) {
          this.$set(this, listName, res.data.data || [])
          store.commit(method, res.data.data || []);
          if (this.$store.state[listName] && this.$store.state[listName].length > 0) {
            for (let item of this.$store.state[listName]) {
              listMap[item.code.toString()] = item.desc;
            }
            this.$set(this, listMapName, listMap)
          }
        }
      })
    } else {
      this.$set(this, listName, this.$store.state[listName])
      if (this.$store.state[listName] && this.$store.state[listName].length > 0) {
        for (let item of this.$store.state[listName]) {
          listMap[item.code.toString()] = item.desc;
        }
        this.$set(this, listMapName, listMap)
      }
    }
  }

  closeDownloadRes() {
    this.downloadResVisible = false;
  }
  /**
   * 发布
   */
  publish(pageId: string, publishStatus: number) {
    updatePageStatus({pageId, publishStatus}).then(res => {
      if (res.data && res.data.code === 200) {
        Message.success(res.data.message)
      } else {
        Message.error(res.data.message)
      }
      this.getPageList();
    })
  }

  /**
   * 关联发布
   */
  associate(pageDetail: AmPageDetail) {
    if (!pageDetail.pages || pageDetail.pages.length === 0) {
      Message.error('没有可以关联的主页')
      return;
    }
    this.associatePageList = pageDetail.pages;
    this.associatePageId = this.associatePageList[0].pageId;
    this.associatePageDetail = {...pageDetail};
    this.associatePageVisible = true;
  }

  associateSubmit() {
    if (!this.associatePageId) {
      Message.error('没有选择关联的主页');
      return;
    }
    this.associatePageDetail.relationPageId = this.associatePageId;
    relationPagePublish(this.associatePageDetail).then(res => {
      if (res.data && res.data.code === 200) {
        Message.success(res.data.message)
      } else {
        Message.error(res.data.message)
      }
      this.getPageList();
    })
    this.associatePageVisible = false;
  }

  associateClose() {
    this.associatePageVisible = false;
  }

  /**
   * 申诉
   */
  appeal(pageId: string, appealStatus: number, message: string) {
    this.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(() => {
      updatePageStatus({pageId, appealStatus}).then(res => {
        if (res.data && res.data.code === 200) {
          Message.success(res.data.message)
        } else {
          Message.error(res.data.message)
        }
        this.getPageList();
      })
    });
  }

  /**
   * 查询
   */
  search(): void {
    this.formData.pageNum = 1;
    this.getPageList();
  }

  /**
   * 重置
   */
  reset(): void {
    this.formData = {pageNum: 1, pageSize: this.formData.pageSize};
    this.createDate = [];
    this.appealDate = [];
  }

  /**
   * 分页大小变化
   * @param val
   */
  handleSizeChange(val: number): void {
    this.formData.pageSize = val;
    this.formData.pageNum = 1;
    this.getPageList();
  }

  /**
   * 当前页面变化
   * @param val
   */
  handleCurrentChange(val: number): void {
    this.formData.pageNum = val;
    this.getPageList();
  }

  /**
   * 打开新链接图片
   * @param url
   */
  openImg(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * 打开新的窗口
   */
  openWindow(url: string): void {
    window.open(url,'_blank')
  }

  /**
   * excel上传点击
   */
  uploadExcel(ref: string) {
    const upload:any = this.$refs[ref];
    upload.click()
  }

  /**
   * excel上传
   */
  async handleUploadChange(i:any) {
    try{
      if (i.target?.files?.length > 0) {
        let params = new FormData()
        params.append('file', i.target.files[0]);
        await savePageExcel(params).then(res => {
          if (res.data && res.data.code === 200) {
            this.downloadResVisible = true;
            this.downloadRes = res.data.data;
            this.getPageList();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
      i.target.value = '';
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * allocate excel上传
   */
  async handleAllocateUploadChange(i:any) {
    try{
      if (i.target?.files?.length > 0) {
        let params = new FormData()
        params.append('file', i.target.files[0]);
        await saveAllocateExcel(params).then(res => {
          if (res.data && res.data.code === 200) {
            this.downloadResVisible = true;
            this.downloadRes = res.data.data;
            this.getPageList();
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
      i.target.value = '';
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * excel下载
   */
  async getPageExcel(): Promise<void> {
    if (this.excelCtrl) {
      this.excelCtrl = false;
      try {
        await getPageExcel(this.formData).then((res: any) => {
          this.handleExcelRes(res);
        })
      } catch (e) {}
      this.excelCtrl = true;
    }
  }

  /**
   * excel模板下载
   */
  async getTempExcel(): Promise<void> {
    if (this.tempCtrl) {
      this.tempCtrl = false;
      try {
        await getTempExcel(this.formData).then((res: any) => {
          this.handleExcelRes(res);
        })
      } catch (e) {}
      this.tempCtrl = true;
    }
  }

  /**
   * 失败明细excel模板下载
   */
  async getFailExcel(requestId: string): Promise<void> {
    if (requestId == undefined) {
      return;
    }
    if (this.failInfoCtrl) {
      this.failInfoCtrl = false;
      try {
        await getFailExcel({requestId}).then((res: any) => {
          this.handleExcelRes(res);
        })
      } catch (e) {}
      this.failInfoCtrl = true;
    }
  }

  handleExcelRes(res: any) {
    const blob = new Blob(
      [res.data], {type: 'application/vnd.ms-excel; chartset=utf-8'})
    const aEle = document.createElement('a');     // 创建a标签
    const href = window.URL.createObjectURL(blob);       // 创建下载的链接
    aEle.href = href;
    aEle.download = decodeURI(res.headers['content-disposition'].replace('attachment;filename=', ''));  // 下载后文件名
    document.body.appendChild(aEle);
    aEle.click();     // 点击下载
    document.body.removeChild(aEle); // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  }
}

